module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('strong', [_vm._v("ZONDERVAN")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("The Naked Gospel")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Copyright © 2009 by Andrew Farley"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All rights reserved under International and Pan-American Copyright Conventions. By payment of the required fees, you have been granted the non-exclusive, non-transferable right to access and read the text of this ebook on screen. No part of this text may be reproduced, transmitted, downloaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented, without the express written permission of Zondervan."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ePub Edition JULY 2009 ISBN: 978-0-310-56328-0"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Requests for information should be addressed to:"), _c('br'), _vm._v("Zondervan, "), _c('i', [_vm._v("Grand Rapids, Michigan 49530")]), _c('br'), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Farley, Andrew, 1972-")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The naked gospel : the truth you may never hear in church / Andrew Farley.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("p. cm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ISBN 978-0-310-29306-4 (softcover)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Christian life. 2. Theology, Doctrinal—Popular works. I. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("   BV4501.3.F36 2009")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("   230-dc22                                                                         2008054098")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This title is also available in a Zondervan audio edition. Visit www.zondervan.fm."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All Scripture quotations, unless otherwise indicated, are taken from the "), _c('i', [_vm._v("Holy Bible, Today’s New International Version")]), _vm._v("™. TNIV"), _c('sup', [_vm._v("®")]), _vm._v(". Copyright ©2001, 2005 by International Bible Society. Used by permission of Zondervan. All rights reserved."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scripture quotations marked NIV are taken from the "), _c('i', [_vm._v("Holy Bible, New International Version")]), _c('sup', [_vm._v("®")]), _vm._v(". NIV"), _c('sup', [_vm._v("®")]), _vm._v(". Copyright © 1973, 1978, 1984 by International Bible Society. Used by permission of Zondervan. All rights reserved."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scripture quotations marked NASB are taken from the "), _c('i', [_vm._v("New American Standard Bible.")]), _vm._v(" Copyright © 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995 by The Lockman Foundation. Used by permission."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scripture quotations marked NKJV are taken from the "), _c('i', [_vm._v("New King James Version.")]), _vm._v(" Copyright © 1982 by Thomas Nelson, Inc. Used by permission. All rights reserved."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Any Internet addresses (websites, blogs, etc.) and telephone numbers printed in this book are offered as a resource. They are not intended in any way to be or imply an endorsement by Zondervan, nor does Zondervan vouch for the content of these sites and numbers for the life of this book."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Published in association with the literary agency of Alive Communications, Inc., 7680 Goddard Street, Suite 200, Colorado Springs, CO 80920. www.alivecommunications.com"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Interior design by Beth Shagene"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("09 10 11 12 13 14 · 24 23 22 21 20 19 18 17 16 15 14 13 12 11 10 9 8 7 6 5 4 3 2 1"), _c('br'), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a94557b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005copyright.vue
// module id = 66
// module chunks = 0